/**
 * @created on 2018/11/8
 * @author htd
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let YIAPP_HOST = getRunTime('//yiapp.xinli001.com')

module.exports = {
  isLogin: `${HOST}/ajax/get-user-header`,
  getTag: `${HOST}/qa/get-question-tags.json`,
  postQuestion: `${YIAPI_HOST}/v5/yi/post-qa-question.json`,
  rewardApi: `${YIAPP_HOST}/qaRewardRecord/postReward`,
  postQuestionRelease: `${HOST}/qa/post-question-release`, // 不进行悬赏直接发布时调用此接口
  payStatus: `${YIAPP_HOST}/qaRewardRecord/queryOrderStatus`,
  login: `${HOST}/account/login`,
  testDraft: `${HOST}/qa/check-question-status.json`, // 是否在草稿行列
  getDataBeforeQuestion: `${HOST}/psychic-coach/get-data-before-question.json`
}



// WEBPACK FOOTER //
// ./src/pages/ask/questionProcess/api.js